import {CarinaProvider as Provider} from '@cvent/carina/components/CarinaProvider';
import type {ReactNode} from 'react';

export function CarinaProvider({children}: {children: ReactNode}) {
  return <Provider>{children}</Provider>;
}
